// ApiService method name -> NomOS implementation (same signature, same return type).
// Rule: implementations RESHAPE NomOS responses only; never recompute aggregates client-side.
// One module per endpoint family under ./impl/ (one porter each); add one import + one spread line here.
import { coreImpl } from './impl/core';
import { aggregatesImpl } from './impl/aggregates';
import { fieldopsImpl } from './impl/fieldops';
import { chatImpl } from './impl/chat';
import { plansImpl } from './impl/plans';
import { connectorsImpl } from './impl/connectors';
import { reportsImpl } from './impl/reports';
import { buildingsAdminImpl } from './impl/buildingsAdmin';
import { weeklyStatusEmailImpl } from './impl/weeklyStatusEmail';
import { fieldopsWritesImpl } from './impl/fieldopsWrites';
import { cooImpl } from './impl/coo';
import { initiativesImpl } from './impl/initiatives';
import { referenceDataImpl } from './impl/referenceData';
import { qualityImpl } from './impl/quality';
import { manualReadingsImpl } from './impl/manualReadings';

export type AnyFn = (...args: never[]) => Promise<unknown>;
export type NomosRegistry = Record<string, AnyFn>;

export const nomosRegistry: NomosRegistry = {
  ...coreImpl,
  ...aggregatesImpl,
  ...fieldopsImpl,
  ...chatImpl,
  ...plansImpl,
  ...connectorsImpl,
  ...reportsImpl,
  ...buildingsAdminImpl,
  ...weeklyStatusEmailImpl,
  ...fieldopsWritesImpl,
  ...cooImpl,
  ...initiativesImpl,
  ...referenceDataImpl,
  ...qualityImpl,
  ...manualReadingsImpl,
};
